<template>
  <div class="knowledge-learn 22" v-if="subjectList.length>0">
    <div class="knowledge-header" >
      <header class="header" ref="header">
      <ul class="header__subject">
        <li
          v-for="item in subjectList"
          :key="item.subject_id"
          class="pointer"
          :class="{'isactive': item.subject_id===subjectId}"
          @click="subjectChange(item)"
        >
          {{item.subject_name}}
        </li>
      </ul>
    </header>
      <div class="lesson">
        <!-- <el-date-picker
        popper-class="picker-ppp"
        @change="pickChange"
          v-model="dateRange"
          type="daterange"
          unlink-panels
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          >
        </el-date-picker> -->
        <div class="week-picker-wrapper">
          <el-date-picker
            ref="weekPicker"
            popper-class="picker-ppp"
            @change="pickChange"
            v-model="dateRange"
            type="week"
            value-format="yyyy-MM-dd"
            range-separator="至"
            :default-value="Date.now() - 29 * 24 * 3600 * 1000"
            :picker-options="pickerOptions"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="week-picker-input"
            >
          </el-date-picker>
          <div class="week-picker-display" @click="openWeekPicker">
            <i class="el-icon-date"></i>
            <span>{{ weekDisplayText }}</span>
          </div>
        </div>
      </div>
    </div>
     <StudyStatistic :subjectId="subjectId" :studyResults="studyResults"/>
     <EffectAnalysis :effect="effect" />
     <KnowledgeDetail
      :subjectId="subjectId"
      :detailList="detailList"
      :dataCount="dataCount"
      @sizeChange="knowledgeSizeChange"
      @currentChange="knowledgeCurrentChange"
    />
  </div>
  <div v-else>
      <Empty content="暂无数据~"/>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import StudyStatistic from './study-statistic.vue';
import EffectAnalysis from './effect-analysis.vue';
import KnowledgeDetail from './knowledge-detail.vue';
import { getTagCodeStudySituation, getStudentKnowledgeDetails } from '@/api/pt';
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'AdaptiveLearn',
  props: ['account_id', 'class_id', 'school_id', 'subjectList', 'school_master_class_id'],
  data() {
    const getDefaultWeekRange = () => {
      const today = dayjs();
      const day = today.day();
      const monday = day === 0 ? today.subtract(6, 'day') : today.subtract(day - 1, 'day');
      // type="week" 时，返回周一日期字符串（符合 value-format="yyyy-MM-dd"）
      return monday.format('YYYY-MM-DD');
    };
    return {
      dateRange: getDefaultWeekRange(),
      pickerMinDate: '',
      pickerOptions: {
        firstDayOfWeek: 1,
        // disabledDate: (time) => {
        //   if (this.pickerMinDate !== '') {
        //     const day30 = (30 - 1) * 24 * 3600 * 1000;
        //     let maxTime = this.pickerMinDate + day30;
        //     if (maxTime > new Date()) {
        //       maxTime = new Date();
        //       return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
        //     }
        //     return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
        //   }
        //   return time.getTime() > Date.now();
        // },

      },
      subjectId: 0, // 科目Id
      courseList: [], // 课程列表
      courseId: 0, // 课程Id
      studyResults: {}, // 学习成果数据
      detailList: [], // 学习详情列表
      effect: {}, // 学习效果分析
      list: [],
      value: 0,
      dataCount: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    weekDisplayText() {
      if (!this.dateRange) {
        return '请选择日期';
      }
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return '请选择日期';
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      return `${weekStart.format('YYYY-MM-DD')} 至 ${weekEnd.format('YYYY-MM-DD')}`;
    },
  },
  mounted() {
    this.subjectId = this.subjectList[0].subject_id;
    this.pickChange();
  },
  components: {
    StudyStatistic,
    EffectAnalysis,
    KnowledgeDetail,
    Empty,
  },
  methods: {
    getAlignedWeekRange(date) {
      const target = dayjs(date);
      const day = target.day();
      const monday = day === 0 ? target.subtract(6, 'day') : target.subtract(day - 1, 'day');
      const sunday = monday.add(6, 'day');
      return [monday, sunday];
    },
    openWeekPicker() {
      if (!this.$refs.weekPicker) {
        return;
      }
      // 通过点击输入框来打开选择器
      const input = this.$refs.weekPicker.$el.querySelector('input');
      if (input) {
        input.click();
        return;
      }
      // 如果找不到输入框，尝试直接设置 visible
      if (this.$refs.weekPicker.pickerVisible !== undefined) {
        this.$refs.weekPicker.pickerVisible = true;
      }
    },
    subjectChange(i) {
      this.subjectId = i.subject_id;
      this.pickChange();
    },
    getTagCodeStudySituation(startDate, endDate) {
      const params = {
        school_id: this.school_id,
        class_id: this.class_id,
        school_master_class_id: this.school_master_class_id,
        subject_id: this.subjectId,
        account_id: this.account_id,
        course_id: 0,
        start_time: startDate,
        end_time: endDate,
      };
      getTagCodeStudySituation(params).then((res) => {
        this.list = res.data;
        this.studyResults = res.data.result;
        // this.detailList = res.data.detail;
        this.effect = res.data.effect;
      });
    },
    subjectClick(item) {
      this.subjectId = item.subject_id;
    },
    pickChange() {
      if (!this.dateRange) {
        return;
      }
      // type="week" 时，dateRange 是单个日期字符串（格式：yyyy-MM-dd）
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return;
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      // 更新 dateRange：type="week" 时保持为单个日期字符串（周一）
      this.dateRange = weekStart.format('YYYY-MM-DD');
      // 格式化日期用于 API 调用
      const startDate = weekStart.format('YYYYMMDD');
      const endDate = weekEnd.format('YYYYMMDD');
      this.getTagCodeStudySituation(startDate, endDate);
      this.queryStudentKnowledgeDetails();
    },
    queryStudentKnowledgeDetails() {
      if (!this.dateRange) {
        return;
      }
      // type="week" 时，dateRange 是单个日期字符串
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return;
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      const params = {
        class_id: this.class_id,
        school_master_class_id: this.school_master_class_id,
        subject_id: this.subjectId,
        account_id: this.account_id,
        course_id: '',
        start_time: weekStart.format('YYYYMMDD'),
        end_time: weekEnd.format('YYYYMMDD'),
        sort: '',
        descSort: '',
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      getStudentKnowledgeDetails(params).then((res) => {
        this.detailList = res.data.detail;
        this.dataCount = res.data.total;
      });
    },
    knowledgeSizeChange(v) {
      this.pageSize = v;
      this.queryStudentKnowledgeDetails();
    },
    knowledgeCurrentChange(v) {
      this.currentPage = v;
      this.queryStudentKnowledgeDetails();
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-learn{
  background-color: #fff;
  padding: 0px 19px 50px 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  .knowledge-header{
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .header__subject {
      display: flex;
      height: 40px;
      font-size: 14px;
      padding: 2px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 40px;
      background: #F0F2F5;
      border-radius: 4px;
      li {
        width: 90px;
        text-align: center;
        &:hover {
          color: #1989FA;
        }
      }
    }
    .isactive {
      background-color: #FFF;
      color: #1989FA;
      border-radius: 2px;
    }
  }
    .knowledge-subject{
      .subject-type{
        font-size: 16px;
        color: #000000;
        margin-right:30px ;
      }
      .subject-item:last-child{
        font-size: 14px;
        color: #303133;
        cursor: pointer;
      }
      .subject-item:not(:last-child){
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        cursor: pointer;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 50px;
          top: 40px;
          position: absolute;
        }
      }
      .active{
        color: #1989FA !important;
      }
    }
  }
  .week-picker-wrapper {
    position: relative;
    display: inline-block;
    .week-picker-input {
      /deep/ .el-input__inner {
        opacity: 0;
        position: absolute;
        z-index: 1;
        cursor: pointer;
      }
    }
    .week-picker-display {
      position: absolute;
      left: 0;
      top: 0;
      width: 240px;
      height: 40px;
      line-height: 40px;
      padding: 0 15px 0 30px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
      font-size: 14px;
      color: #606266;
      box-sizing: border-box;
      z-index: 0;
      display: flex;
      align-items: center;
      &:hover {
        border-color: #C0C4CC;
      }
      .el-icon-date {
        position: absolute;
        left: 10px;
        font-size: 16px;
        color: #C0C4CC;
        pointer-events: none;
      }
      span {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

</style>
